import { render } from "./FooterCustom.vue?vue&type=template&id=d9efa86c"
import script from "./FooterCustom.vue?vue&type=script&lang=js"
export * from "./FooterCustom.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__